export function sleep(timeout = 1000) {
  return new Promise(function (resolve, reject) {
    try {
      setTimeout(resolve, timeout);
    } catch (error) {
      reject(error);
    }
  });
}
